module.exports = __webpack_public_path__ + "img/CausewayPass.fb3a98a9.png";